import styled from 'styled-components';
import type { AIToolComponent } from './GuardianMarkdown';

const ThinkingLoaderWrapper = styled.span`
  font-size: 1rem;
  display: inline-block;
`;

const WavingChar = styled.span<{ idx: number }>`
  counter-increment: char-counter;
  animation: shimmer 4.4s linear infinite;
  animation-delay: calc(${(props) => props.idx} * 0.1s);
  background: linear-gradient(90deg, #fff 0%, #858585ff 50%, #fff 100%);
  background-size: 8000% 100%;
  background-clip: text;
  color: transparent;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const ThinkingLoader: AIToolComponent<{ message?: string }> = ({ params }) => {
  const message = params?.message ?? 'Thinking...';
  const chars = message.split('');

  return (
    <ThinkingLoaderWrapper>
      {chars.map((char, i) => (
        <WavingChar key={i} idx={i}>
          {char}
        </WavingChar>
      ))}
    </ThinkingLoaderWrapper>
  );
};

ThinkingLoader.description = 'Displays an animated loading message with shimmer effect.';
ThinkingLoader.schema = {
  type: 'object',

  properties: {
    message: {
      type: 'string',
      description: 'The loading message to display with shimmer effect',
      default: 'Thinking...',
    },
  },
  additionalProperties: false,
};

export { RETRYING_TEMPLATE, THINKING_TEMPLATE } from './thinkingTemplates';
